export default __webpack_public_path__ + "static/media/dallas.801273ba.png";